<template>
<div class="clubGallery">
  <div class="clubGallery__header">
    <div class="clubGallery__header-title">
      Галерея
    </div>
    <div class="clubGallery__header-buttons">
      <ActionButton>
        <template #caption>
          <svg width="30" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.625 10.5H4.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.5 16.625L4.375 10.5L10.5 4.375" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

        </template>
      </ActionButton>
      <ActionButton>
        <template #caption>
          <svg width="30" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.375 10.5H16.625" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10.5 4.375L16.625 10.5L10.5 16.625" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>

        </template>

      </ActionButton>
    </div>
  </div>
    <div class="clubGallery__images">
      <img class="clubGallery__image" :src="require('@/assets/img/club/galery/1.png')"/>
      <img class="clubGallery__image" :src="require('@/assets/img/club/galery/2.png')"/>
    </div>


</div>
</template>

<script>
import ActionButton from "@/components/ui/ActionButton.vue";

export default {
  name: "ClubGallery",
  components: {ActionButton}
}
</script>

<style scoped lang="scss">
.clubGallery {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: $space-sm;
  }

  &__header-title {
    text-align: left;
    font-weight: 500;
    font-family: var(--cd-bold-font);
    font-size: clamp(24px, 4vw, 36px);
  }

  &__header-buttons {
    display: flex;
    gap: 13px;
    padding-right: 0;
  }

  &__images {
    display: flex;
    flex-wrap: wrap;
    gap: 13px;
    width: 100%;
    padding-top: 24px;

    img {
      flex: 1 1 300px;
      min-width: 0;
      width: 49%;
      height: auto;
      border-radius: var(--cd-card-border-radius);
      object-fit: cover;

      @include respond-to('sm') { width: 100%; flex: 1 1 100%; }
    }
  }
}
</style>
